//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {storageRef} from '../../../../../firebase';
//import Components
import {Button, Row, Col, Form, FormGroup, Label, Input} from 'reactstrap'

import ImageSelector from '../../ImageSelector/ImageSelector';
import EditConfirmButton from '../../EditConfirmButton/EditConfirmButton';
import UpDownButton from '../../UpDownButton/UpDownButton';


import * as imageActions from '../../../actions/imageActions';
import * as validations from '../../../ProductManager/Category/Product/InputValidation';

//import Styles
import "./DepartmentSliderFormLine.css";

class DepartmentSliderFormLine extends Component {

    constructor(props) {
        super(props);

        const { count } = props.data;

        this.state = {
            imageEditing : false,
            count : count ? count : 0,
            prevCount : count ? count : 0,
            reloads : new Array(count ? count : 0).fill(true),
            images : [],
            files : [],
            urls : [],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshow) {
        for(let i = 0; i < this.state.reloads.length; ++i) {
            if (!prevState.reloads[i] && this.state.reloads[i]) {
                this.loadImageFromStorage(i);
            }
        }
        if(prevProps.data.id !== this.props.data.id){
            for(let i = 0; i < this.state.reloads.length; ++i) {
                this.loadImagesFromStorage(i);
            }
        }
    }

    componentDidMount() {
        this.loadImagesFromStorage();
    }

    toggleImageEditing = () => {
        this.setState((prevState) => ({
            imageEditing : !prevState.imageEditing,
            images : [],
            files : []
        }))
    }

    handleOnFileChange = (e) => {
        if(e.target.files && e.target.files[0]) {

            const files = e.target.files;
            this.setState((prevState) => ({
                count : files.length,
                prevCount : prevState.count,
                reloads : new Array(files.length).fill(false),
                images : new Array(files.length),
                files : new Array(files.length),
                urls : new Array(files.length),
            }))

            for(let i = 0; i < e.target.files.length; ++i) {
                const file = e.target.files[i];
                let reader = new FileReader();
                reader.onload = (event) => {
                    let images = [...this.state.images]
                    let files = [...this.state.files];

                    images[i] = event.target.result;
                    files[i] = file;
                    this.setState({
                        images,
                        files
                    })
                }
                reader.readAsDataURL(e.target.files[i]);
            }
        }
    }

    loadImagesFromStorage = () => {
        this.setState({
            files : [],
            urls :[] 
        })
        for(let i = 0; i < this.state.count; ++i) {
            this.loadImageFromStorage(i);
        }
    }

    loadImageFromStorage = (index) => {
        let urls = [
            ...this.state.urls
        ]
        let reloads = [
            ...this.state.reloads
        ]

        console.log(index);

        storageRef.child(`${this.props.storagePath}/${this.props.data.id}_${index}.jpg`).getDownloadURL()
            .then((url) => {
                urls[index] = url;
                reloads[index] = !reloads[index];
                this.setState({
                    urls, 
                    reloads
                })
            })
            .catch(e => {
                reloads[index] = !reloads[index];
                this.setState({
                    reloads
                })
            })
    }


    // makeReload = (index) => {
    // }

    render(){
        const {koName, koContent, enName, enContent} = this.props;
        const {editing} = this.props;

        const renderImgFromDatabase = (
            this.state.images && this.state.urls.map((url, index) => {
                return (
                    <div className="SliderImages">
                        <img className="selector-image" src={url} alt={url} />
                    </div>
                    
                )
            })
        );
        const renderImgFromLocal = (
            this.state.images && this.state.images.map((image, index) => {
                return (
                    <img className="selector-image" src={image} />
                )
            })
        );

const renderMultipleImageSelector = (
        <Col>
        {
            this.state.imageEditing ?
                renderImgFromLocal : 
                renderImgFromDatabase
        }
        {
            this.state.imageEditing ? 
            (
                <div>
                    <Input
                        type="file"
                        name="file"
                        id="seletor-img"
                        onChange={this.handleOnFileChange}
                        bsSize="sm"
                        multiple={true}
                    />
                    <Button
                        onClick={() => {
                            this.props.onUpdate(
                                this.props.dbPath,
                                this.props.data.id, {
                                    type: this.props.type,
                                    count: this.state.count,
                                    name: {
                                        en: enName,
                                        ko: koName
                                    },
                                    content: {
                                        en: enContent,
                                        ko: koContent
                                    },
                                    promotion : this.props.promotion
                                });
                            this.props.onUpdateImages(
                                this.props.storagePath,
                                this.props.data.id,
                                this.state.files,
                                this.state.prevCount,
                                null,
                                (i) => {
                                    let reloads = [...this.state.reloads];
                                    reloads[i] = true;
                                    console.log(reloads);
                                    this.setState({
                                        reloads
                                    })
                                }, 
                                () => {

                                });
                            this.toggleImageEditing();
                        }}
                        color="warning"
                        size="sm"
                        disabled={this.state.files.length === 0}
                        outline
                    >
                        확인
                    </Button>
                    <Button
                        onClick={this.toggleImageEditing}
                        color="danger"
                        size="sm"
                        outline
                    >
                        취소
                    </Button>
                </div>
            ) : (
                <div>
                    <Button
                        color="info"
                        onClick={this.toggleImageEditing}
                        size="sm"
                        outline
                    >
                        이미지편집
                    </Button>
                </div>
            )
        }
        </Col>
    );

    return (
        <div>
            <Row>
                <Col>
                    <ImageSelector
                        storagePath={this.props.storagePath}
                        imageId={this.props.data.id}
                    />
                </Col>
                <Col>
                    <Form>
                        <FormGroup>
                            <Label className="mr-sm-2">제목</Label>
                            <Input
                                type="text"
                                name="koName"
                                value={koName}
                                onChange={this.props.handleOnChange}
                                disabled={!editing}
                                bsSize="sm"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label className="mr-sm-2">내용</Label>
                            <Input
                                type="textarea"
                                name="koContent"
                                value={koContent}
                                onChange={this.props.handleOnChange}
                                disabled={!editing}
                                bsSize="sm"
                            />
                        </FormGroup>
                    </Form>
                </Col>
                <Col>
                    <Form>
                        <FormGroup>
                            <Label className="mr-sm-2">Title</Label>
                            <Input
                                type="text"
                                name="enName"
                                value={enName}
                                onChange={this.props.handleOnChange}
                                disabled={!editing}
                                bsSize="sm"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label className="mr-sm-2">Content</Label>
                            <Input
                                type="textarea"
                                name="enContent"
                                value={enContent}
                                onChange={this.props.handleOnChange}
                                disabled={!editing}
                                bsSize="sm"
                            />
                        </FormGroup>
                    </Form>
                </Col>
                <Col sm={1}>
                    <UpDownButton
                        disabled={this.props.editAnything}
                        onOrderUp={() => {
                            this.props.onDataOrderSwitch(this.props.dbPath, this.props.index, this.props.index - 1);
                        }}
                        onOrderDown={() => {
                            this.props.onDataOrderSwitch(this.props.dbPath, this.props.index, this.props.index + 1);
                        }}
                    />
                    <EditConfirmButton
                        editing={editing}
                        onConfirm={() => {
                            this.props.onUpdate(
                                this.props.dbPath,
                                this.props.data.id, {
                                    type: this.props.type,
                                    count: this.state.count,
                                    name: {
                                        en: enName,
                                        ko: koName
                                    },
                                    content: {
                                        en: enContent,
                                        ko: koContent
                                    },
                                    promotion : this.props.promotion
                                })
                        }}
                        onToggleEditing={() => {
                            this.props.onToggleEditing();
                        }}
                        onRemove={() => {
                            this.props.onRemove(this.props.dbPath,
                                this.props.storagePath, {
                                    id: this.props.data.id,
                                    count: this.state.count
                                })
                        }}
                    />
                </Col>
            </Row>
            <Row>
                {
                    renderMultipleImageSelector
                }
            </Row>
        </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onUpdateImages : (storagePath, id, file, prevCount, beforeUpdateFunc, successFunc, failedFunc) => {
            dispatch(imageActions.updateImages(storagePath, id, file, prevCount, beforeUpdateFunc, successFunc, failedFunc))
        }
    }
}

export default connect(null, mapDispatchToProps)(DepartmentSliderFormLine);

DepartmentSliderFormLine.propTypes = {
    data : PropTypes.object.isRequired,
    onUpdate : PropTypes.func.isRequired,
    onRemove : PropTypes.func.isRequired,
    storagePath : PropTypes.string.isRequired,
}

DepartmentSliderFormLine.defaultProps = {
    onUpdate : null,
    onRemove : null,
}


// WEBPACK FOOTER //
// ./src/pages/Admin/Components/AdminDepartmentFormManager/FormLines/DepartmentSliderFormLine.js